import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import 'jquery-slimscroll';
import { NgSelect2Module } from 'ng-select2';
import { TooltipModule } from 'ngx-bootstrap';

import { AppCommonModule } from '../common/common.module';
import { DynamicModalModule } from '../common/modals/dynamic-modal/dynamic-modal.module';
import { DocumentApprovalFlowGuard } from '../common/permissions/document-approval-flow.guard';
import { OverviewV2Guard } from '../overview-v2/guards/overview-v2.guard';
import { OverviewService } from '../overview/overview.service';

import { FeatureGuard } from './guards/feature.guard';
import { NavbarComponent } from './navbar/navbar.component';
import { ShellResolver } from './shell-resolver.guard';
import { ShellComponent } from './shell.component';
import { ROUTES } from './shell.routes';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidebarService } from './sidebar/sidebar.service';

@NgModule({
  imports: [
    CommonModule,
    AppCommonModule,
    TooltipModule.forRoot(),
    ROUTES,
    FormsModule,
    NgSelect2Module,
    DynamicModalModule
  ],
  declarations: [
    ShellComponent,
    SidebarComponent,
    NavbarComponent
  ],
  providers: [
    OverviewService,
    ShellResolver,
    FeatureGuard,
    SidebarService,
    OverviewV2Guard,
    DocumentApprovalFlowGuard
  ]
})
export class ShellModule {}
